import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";
import {
  AddPlayerToMatchRequest,
  CreatePlayerRequest,
  RemovePlayerFromMatchRequest,
} from "interfaces/requests/Players";

const BASE_URL = "/players";

export const addPlayer = createAsyncThunk(
  "players/add",
  async (request: CreatePlayerRequest) => {
    try {
      const response = await axios.post(`${BASE_URL}/`, request);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - addPlayer ->", error);
      throw new Error(error.message);
    }
  },
);

export const addPlayerToMatch = createAsyncThunk(
  "players/addToMatch",
  async (request: AddPlayerToMatchRequest) => {
    try {
      const response = await axios.patch(`${BASE_URL}/addToMatch`, request);
      console.log("response -->", response);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - addPlayerToMatch ->", error);
      throw new Error(error.message);
    }
  },
);

export const deletePlayerFromMatch = createAsyncThunk(
  "players/removeFromMatch",
  async (request: RemovePlayerFromMatchRequest) => {
    try {
      const response = await axios.patch(
        `${BASE_URL}/removeFromMatch`,
        request,
      );
      return response.data.data;
    } catch (error: any) {
      console.log("Error - removeFromMatch ->", error);
      throw new Error(error.message);
    }
  },
);
